import {
  StyledIndicator,
  StyledIndicatorCircle,
  StyledBackgroundCircle,
} from './styled';
import type { IndicatorStatus } from './styled';

interface Props {
  percent: number;
  percentWarnLimit?: number;
}

export const Indicator = ({ percent, percentWarnLimit }: Props) => {
  const initDashoffset = 56.27054;
  const strokeDasharray = initDashoffset;
  const strokeDashoffset = initDashoffset - initDashoffset * percent;

  let status: IndicatorStatus = 'good';

  if (typeof percentWarnLimit !== 'undefined' && percent >= percentWarnLimit) {
    status = 'warning';
  }

  if (percent === 1) {
    status = 'complete';
  }

  return (
    <StyledIndicator>
      <svg height="100%" viewBox="0 0 20 20" width="100%">
        <StyledBackgroundCircle />
        <StyledIndicatorCircle
          $status={status}
          $strokeDashoffset={strokeDashoffset}
          $strokeDasharray={strokeDasharray}
        ></StyledIndicatorCircle>
      </svg>
    </StyledIndicator>
  );
};
